<template>
    <div class="initiation-process">
        <div class="system-box house-table-box">
            <header class="top-header">
                <div class="breadcrumb">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item :to="{ path: '/work-portal/index' }">
                            <i class="icon-home"></i> 首页
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>发起流程</el-breadcrumb-item>
                    </el-breadcrumb>
                    <el-button type="" size="mini" @click="handleClose">关闭</el-button>
                </div>
            </header>
            <div class="content-box">
                <div class="aside">
                    <common-process
                        ref="commonProcess"
                        @loadProcessUrlById="loadProcessUrlById"
                        @pageRedirect="pageRedirect"
                    ></common-process>
                </div>
                <div class="main">
                    <classify-process ref="classifyProcess" @loadProcessUrlById="loadProcessUrlById"></classify-process>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClassifyProcess from "./components/classify-process.vue";
import CommonProcess from "./components/common-process.vue";
import { getLocalStorage } from "@/libs/mUtils";
import { saveRecentProcess, getProcessUrlById } from "@/api";
export default {
    name: "InitiationProcess",
    components: {
        ClassifyProcess,
        CommonProcess,
    },
    data() {
        return {};
    },
    methods: {
        loadProcessUrlById(params, nodeData) {
            getProcessUrlById(params).then((res) => {
                if (res.body) {
                    this.pageRedirect(params.id, nodeData, res.body);
                }
            });
        },

        // 页面重定向
        pageRedirect(id, nodeData, url) {
            if (!url) {
                console.error("未获取到跳转地址！");
                return;
            }
            this.saveRecentProcess(id);
            const queryStr = "token=" + getLocalStorage("user").oauth.access_token;
            if (!url && typeof url !== "string") {
                return;
            }
            url = url.includes("?") ? `${url}&${queryStr}` : `${url}?${queryStr}`;
            // case1: 是 nbpm 发起的流程
            if (nodeData.ifNbpm) {
                this.$router.push({ name: "iframeApp", query: { url: url } });
                return;
            }
            /**
             * case2:不是 nbpm 发起的流程
             *  openWay: 0, // 0 新页面，1 当前页面
             */
            if (nodeData.openWay == 0) {
                setTimeout(() => {
                    window.open(url, "_blank");
                }, 0);
                return;
            }
            this.$router.push({ name: "iframeApp", query: { url: url, closeBtn: true } });
        },

        // 保存点击的流程数据
        saveRecentProcess(id) {
            let params = {
                username: getLocalStorage("user").oauth.userName || "",
                powerProcessId: id,
            };
            saveRecentProcess(params).then((res) => {
                if (res.status) {
                    console.log("流程保存成功！");
                }
            });
        },
        handleClose() {
            this.$router.push({
                path: "/work-portal/index",
            });
        },
    },
};
</script>

<style scoped lang="scss">
@import "./style.scss";
</style>
